import { useEffect, useState } from 'react'

/**
 * Triggers a re-render at every wall-clock minute boundary (e.g. 10:04:00, 10:05:00).
 * Components using this hook will always reflect the same current-minute value.
 */
export function useMinuteTick() {
  const [, setTick] = useState(0)

  useEffect(() => {
    const bump = () => setTick((v) => (v + 1) % 1_000_000)
    let intervalId: ReturnType<typeof setInterval> | undefined

    const msUntilNextMinute = 60_000 - (Date.now() % 60_000)
    const timeout = setTimeout(() => {
      bump()
      intervalId = setInterval(bump, 60_000)
    }, msUntilNextMinute)

    return () => {
      clearTimeout(timeout)
      if (intervalId) clearInterval(intervalId)
    }
  }, [])
}
